/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu85zaO%7Bgap%3Avar(--ds-space-200%2C1pc)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._2WAcuGIZbP%7Boverflow-y%3Aauto%7D%0A._0LQT5ENHnM%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D%0A._03SyCPNHnM%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D%0A._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D%0A._0xmtko5zaO%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._0KLXruGsB2%7Bbackground-color%3Avar(--ds-skeleton%2C%230515240f)%7D%0A._0jFU0VSPN1%7Bheight%3A20px%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._39xV02ygnw%7Bwidth%3A60%25%7D%0A._39xV02gE1Q%7Bwidth%3A80%25%7D%0A._39xV02iLlu%7Bwidth%3A40%25%7D");















import { memo, type MemoExoticComponent, type ReactNode } from 'react';
import { fg } from '@atlaskit/platform-feature-flags/fg';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { PreviewPanel } from '@atlassian/preview-panel/preview-panel';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { PreviewPanelBody } from '@atlassian/preview-panel/preview-panel-body';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { PreviewPanelHeader } from '@atlassian/preview-panel/preview-panel-header';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { PreviewPanelTitle } from '@atlassian/preview-panel/preview-panel-title';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { usePreviewPanelsNavigation } from '@atlassian/preview-panels-api/preview-panel-navigation';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api/use-preview-panel-actions';
type Props = {
  icon: ReactNode;
  name: string;
  url: string;
};
const styles = {
  body: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _2WAcuGIZbP _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO",
  skeleton: "_0bjKvDKxmn _3iDTPbQ4SZ _0KLXruGsB2 _0jFU0VSPN1",
  skeletonRow1: "_39xV02N91d",
  skeletonRow2: "_39xV02ygnw",
  skeletonRow3: "_39xV02gE1Q",
  skeletonRow4: "_39xV02iLlu"
};
export const FallbackPreviewPanel: MemoExoticComponent<({
  url,
  name,
  icon
}: Props) => JSX.Element> = memo(({
  url,
  name,
  icon
}: Props): JSX.Element => {
  const {
    close
  } = usePreviewPanelsActions();
  const {
    canNavigateBack,
    navigateBack
  } = usePreviewPanelsNavigation();
  return <PreviewPanel>
			<PreviewPanelHeader onClose={close} onNavigateBack={canNavigateBack && fg('jivtech-1920-back-navigation-gpp') ? navigateBack : undefined} url={url}>
				<PreviewPanelTitle title={name} icon={icon} />
			</PreviewPanelHeader>
			<PreviewPanelBody styles={styles.body}>
				<div className={ax([styles.skeleton, styles.skeletonRow1])}></div>
				<div className={ax([styles.skeleton, styles.skeletonRow2])}></div>
				<div className={ax([styles.skeleton, styles.skeletonRow3])}></div>
				<div className={ax([styles.skeleton, styles.skeletonRow4])}></div>
				<div className={ax([styles.skeleton, styles.skeletonRow1])}></div>
				<div className={ax([styles.skeleton, styles.skeletonRow2])}></div>
				<div className={ax([styles.skeleton, styles.skeletonRow3])}></div>
				<div className={ax([styles.skeleton, styles.skeletonRow4])}></div>
			</PreviewPanelBody>
		</PreviewPanel>;
});